import { useState, useEffect, useCallback } from "react";
import styles from "./login.module.css";
import { msalInstance1 } from "../../services/msal";
import LoadingDailog from "../../Helper/LoadingDailog";
import { NEXT_API_URL, NEXT_API_URL2 } from "../../Helper/Config";

function LoginComponent({ setScreenName, setNoshow }) {
  const [isLoading, setIsLoading] = useState(false);

  // Handle redirect from Company PIC token URL
  const handleCompanyToken = useCallback(() => {
    const urlParams = new URLSearchParams(
      window.location.hash.replace("#", "?")
    );
    const token = urlParams.get("id_token");

    if (token) {
      setIsLoading(true);
      window.sessionStorage.setItem("companyPicToken", token);
      window.location.href = `${NEXT_API_URL}/bizcareui/api/auth?id_token=${token}`;
    }
  }, []);

  // Handle login redirects
  useEffect(() => {
    handleCompanyToken();
  }, [handleCompanyToken]);

  // Redirect to ADB2C login screen
  const gotoADB2CScreen = useCallback(() => {
    // const clientIdB2C = process.env.NEXT_PUBLIC_ADB2C_CLIENT_ID;
    // const policy = process.env.NEXT_PUBLIC_B2C_POLICY;
    // const redirectUri = process.env.NEXT_PUBLIC_ADB2C_REDIRECT_URI;


    // const base = process.env.NEXT_PUBLIC_B2C_TENANT_BASE_URI;
    // const authUrl = new URL(base);
    const authUrl = process.env.NEXT_PUBLIC_ADB2C_URI;

    // authUrl.searchParams.set("p", policy);
    // authUrl.searchParams.set("client_id", clientIdB2C);
    // authUrl.searchParams.set("nonce", "defaultNonce");
    // authUrl.searchParams.set("redirect_uri", redirectUri);
    // authUrl.searchParams.set("scope", "openid");
    // authUrl.searchParams.set("response_type", "id_token");
    // authUrl.searchParams.set("prompt", "login");

   window.location.href =     
  //  'https://celcomdigib2c.b2clogin.com/celcomdigib2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_sign_in_with_id&client_id='+clientIdB2C+'&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fprod.bizcare.aws.celcomdigi.com%2Fbizcareui%2Fapi%2Fauth&scope=openid&response_type=id_token&prompt=login';
      authUrl
    // window.location.href = `${NEXT_API_URL2}/bizcareui/api/auth?id_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6InJnVHU2bXJrZEEzYjRZWF9VVVhQUXQwWjlmOWxuRFdSdlVFVndmX1QweFkifQ.eyJleHAiOjE2Njg0MDgxNjgsIm5iZiI6MTY2ODQwNDU2OCwidmVyIjoiMS4wIiwiaXNzIjoiaHR0cHM6Ly9jZWxjb21iMmMuYjJjbG9naW4uY29tL2ZmMzI1ODYxLTljNjAtNDYwYi04NmE3LTc4MWRlMGIzNTViNS92Mi4wLyIsInN1YiI6Ijg0YWQ0ODQwLWU0NjctNDIwNi05YWFhLTcyMzYxM2MxYjBmZCIsImF1ZCI6Ijk2YTYxMDhjLWUxNjUtNDFlYS1hYmJhLWFiMWNiOTk0ZTI1MSIsImFjciI6ImIyY18xYV9hYWRiMmNfcHJvdG8yX3NpZ25pbiIsIm5vbmNlIjoiZGVmYXVsdE5vbmNlIiwiaWF0IjoxNjY4NDA0NTY4LCJhdXRoX3RpbWUiOjE2Njg0MDQ1NjgsImNoYW5uZWxOYW1lIjoiQklaQyIsInNpZ25Jbk5hbWUiOiJTaGFzaGFuayIsInNlc3Npb25JRCI6IjIyNzciLCJuYW1lIjoiU2hhc2hhbmsiLCJ1cG4iOiJTaGFzaGFua0BjZWxjb21iMmMub25taWNyb3NvZnQuY29tIiwiaXNGb3Jnb3RQYXNzd29yZCI6ZmFsc2V9.WdV27cyl4ZNmPrEZmhEnS7X9qZKPYC42FN0RsjwdfV7bZvlNjmHa0C6DDJW4knl6_LbYnXa-prhtM9MP-hkkFKDsSTniQmNqO1fk8IcOBoi1kC99CfNp_1rFLdWre2ieqSMletdSZWRXu3vuD9I6XFUodUYshFRbHZXcXnwffeRmnY0DmImG9u5oboCdwpOz5k_g6d0i7VYFNvex_z02m2JsYwX0oLbJZH0WcMEJ6BPOddbXV7eT9vNQjPmq9gkSZssBbhnvfFJ04h8K89jWfh5XBmd_h_7mzk1rpI6_IRYS44g2BETQDakDiPFtJeR_D0E8YsAm48BdTVIysWfBCg`;
  }, []);

  // Redirect to MSAL sign-in screen
  const gotoSignInScreen = useCallback(async () => {
    window.sessionStorage.removeItem("msal.interaction.status");
    if (window.sessionStorage.getItem("loginType") !== "AD") {
      window.sessionStorage.setItem("loginType", "AD");
      setNoshow(false);
      msalInstance1.loginRedirect();
      setIsLoading(true);
    }
  }, [setNoshow]);

  return (
    <div className={styles.form}>
      <div className={styles.login}>Login</div>
      <div className={styles.upper}>
        <div className={styles.bizcareui}>
          Biz<span className={styles.underlinedBiz}>Care</span>
        </div>
        <div className={styles.newUser}>
          New User ? &ensp;
          <a
            onClick={() => setScreenName("registration")}
            className={styles.register}
          >
            Register
          </a>
        </div>
      </div>
      <div className={styles.bothButton}>
        <button
          className={styles.buttonLogin}
          id={styles.buttonPIC}
          color="celcom-alternate-white"
          type="button"
          onClick={gotoADB2CScreen}
        >
          Company PIC
        </button>
        <button
          className={styles.buttonLogin}
          id={styles.buttonAdmin}
          color="celcom-alternate-white"
          type="button"
          onClick={
            // () => {
            //   window.location.href = `${NEXT_API_URL2}/bizcareui/api/auth/authAdmin?id_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyJ9.eyJhdWQiOiI5NTYxZWFkMi0yMTMwLTQ0NWItYTA1Mi1lYjVkZDIyYmJkMWUiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vYmYwNDg5NzYtNzExMC00ZTg3LTk2ZjMtYzY3NDQ5MDhiOGJlL3YyLjAiLCJpYXQiOjE2ODkxNTc2MzksIm5iZiI6MTY4OTE1NzYzOSwiZXhwIjoxNjg5MTYxNTM5LCJuYW1lIjoiU2hhc2hhbmsgVHJpdmVkaSIsIm5vbmNlIjoiZWZkZmFjMTEtN2FhMy00NGYxLWI3OTQtNWUzMDhiNDBiYzJmIiwib2lkIjoiNjdmZTJmZmEtMzRmYi00M2Y2LWIxODAtMzA1ZjU4OWYyNjI0IiwicHJlZmVycmVkX3VzZXJuYW1lIjoiVjExMTIyWEBjZWxjb20uY29tLm15IiwicmgiOiIwLkFWUUFkb2tFdnhCeGgwNlc4OFowU1FpNHZ0THFZWlV3SVZ0RW9GTHJYZElydlI1VUFEQS4iLCJzdWIiOiJqS01RbGt4SGhDVjNZWHp1c2pMRmFObDYwZ3I5eFZmVkVJVTVDVU03MXY4IiwidGlkIjoiYmYwNDg5NzYtNzExMC00ZTg3LTk2ZjMtYzY3NDQ5MDhiOGJlIiwidXRpIjoiQUtYWHRaNlRRMHVWQk81UXJOQWRBQSIsInZlciI6IjIuMCJ9.MAmE2O_d9i8u0XhfDuuLCtVGh6ftdcZ-cJ09howwzxWnkW-T-eSOjExU3u5oKKR6UWuYllV3zNIKEzWyTIl2DQBHUi45dlGT6xegD9tjHlK4o65AVPuzKu7c9Wy3YQLIq5rHKNJVskG_4Rn0Y8x02wkRsk9oKWANz9cbUpcCkWeF4za5FpPaJ7_bcU-Hir5v4CXwzyg5D7mLFKuhDC6e8iY87z7ihvtPXvpqyBayBPbHbGI2BCy8n5U6Yh4kCcKZnN8AQHiBdEBPO2CJFvbv-of_siIV5_6N-1-EUyjhRwJbSPlq9tZt4hEErWfFpPf8pZ_RMmCIsGHb5CPVVtuuoA`;
            // }
            gotoSignInScreen
          }
        >
          Celcom Admin
        </button>
      </div>
      {isLoading && <LoadingDailog />}
    </div>
  );
}

export default LoginComponent;
